import Button from "@/components/button/Button"
import { useGeneralContext } from "@/components/context/GeneralContext"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { SvgIcon } from "@/components/icon"
import DividerWithHex from "@/components/modal-dark/components/divider-with-hex/DividerWithHex"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"
import "./ConfirmEmergency.less"

const { Title, Paragraph } = WebsiteTypography

const keyPoints = [
  {
    icon: "warning-circle" as const,
    text: "Critical services have been damaged or require immediate repair due to excavation works.",
  },
  {
    icon: "envelope-upload" as const,
    text: "Specific email templates will be sent to all affected parties to expedite resolution.",
  },
  {
    icon: "clock" as const,
    text: "Emergency applications are prioritised and reviewed outside the standard processing queue.",
  },
]

const ConfirmEmergency: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const isMobileScr = !(xxl || xl || lg || md || sm)

  const { setIsModalDarkOpen } = useModalDarkContext()
  const { createAppData, setCreateAppData } = useGeneralContext()

  const handleConfirm = () => {
    setCreateAppData({
      ...createAppData,
      isEmergency: true,
    })
    setIsModalDarkOpen(false)
  }

  const handleClose = () => {
    setIsModalDarkOpen(false)
  }

  return (
    <Row justify={"center"} className={"confirm-emergency-wrapper"} style={{ paddingBottom: 24 }}>
      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        {!isMobileScr && (
          <Row justify={"center"} className={"confirm-emergency-icon-wrapper"}>
            <div className={"confirm-emergency-hex-wrapper"}>
              <SvgIcon type={"emergency-alert"} />
            </div>
          </Row>
        )}

        <Title level={isMobileScr ? 5 : 3} centered className={"section-title"} style={{ paddingTop: 12 }}>
          <span className={"bold"}>{"Emergency Application"}</span>
        </Title>

        <Row justify={"center"} style={{ paddingTop: 4 }}>
          <Col span={24}>
            <Paragraph
              centered
              size={isMobileScr ? "sm" : "md"}
              color={"website-secondary"}
              weight={"w300"}
              style={{ paddingBottom: 24 }}
            >
              {"Please confirm that this application qualifies as an emergency before proceeding."}
            </Paragraph>
          </Col>
        </Row>
      </Col>

      <DividerWithHex />

      <Col span={20} xxl={20} xl={20} lg={20} md={24} sm={24} xs={24}>
        <Row gutter={[0, 16]} style={{ paddingBottom: 8 }}>
          <Col span={24}>
            <Paragraph
              size={isMobileScr ? "xs" : "sm"}
              color={"website-secondary"}
              weight={"w700"}
              style={{ paddingBottom: 4 }}
            >
              {"An Emergency Application applies when:"}
            </Paragraph>
          </Col>

          {keyPoints.map((point, idx) => (
            <Col key={idx} span={24}>
              <Row align={"middle"} wrap={false} gutter={[12, 0]} className={"confirm-emergency-key-point"}>
                <div className={"confirm-emergency-bullet"}>
                  <SvgIcon type={"orange-circles"} />
                </div>
                <Paragraph size={isMobileScr ? "xs" : "sm"} color={"website-secondary"} weight={"w300"}>
                  {point.text}
                </Paragraph>
              </Row>
            </Col>
          ))}
        </Row>
      </Col>

      {/*<Row justify={"center"} className={"divider-with-hex"} style={{ margin: "16px 0 24px 0" }}>*/}
      {/*  <div className={"hex-small"} />*/}
      {/*</Row>*/}

      <DividerWithHex />

      <Row justify={"center"} style={{ paddingTop: 8 }} gutter={[16, 16]}>
        <Col span={isMobileScr ? 24 : 12}>
          <Button btnType={"ghost"} text={"Cancel"} onClick={handleClose} block textColor={"white"} size={"large"} />
        </Col>

        <Col span={isMobileScr ? 24 : 12}>
          <Button btnType={"primary"} text={"Confirm Emergency"} onClick={handleConfirm} block size={"large"} />
        </Col>
      </Row>
    </Row>
  )
}

export default ConfirmEmergency
